module.exports = __webpack_public_path__ + "static/cs-hero-detail-layer-fd988ea1993e6fa7f96d107118e8bacc.png";